import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { tokens, cardElevation } from "../../PartnerRoutingAndPacking/styles";

// Floating +/- zoom buttons. The native zoomControlEnabled control pins
// to the map's bottom-right where our bottom sheet sits, so we draw our
// own and let each screen position them via `style`.
const ZoomControls = ({ mapRef, style }) => {
  const zoomBy = async (delta) => {
    const map = mapRef.current;
    if (!map) return;
    try {
      const cam = await map.getCamera();
      map.animateCamera({ zoom: (cam.zoom || 15) + delta }, { duration: 150 });
    } catch (_e) {
      // camera unavailable before the map is ready — ignore
    }
  };
  return (
    <View style={[styles.wrap, style]}>
      <TouchableOpacity
        style={styles.btn}
        activeOpacity={0.7}
        onPress={() => zoomBy(1)}
      >
        <Text style={styles.glyph}>+</Text>
      </TouchableOpacity>
      <View style={styles.divider} />
      <TouchableOpacity
        style={styles.btn}
        activeOpacity={0.7}
        onPress={() => zoomBy(-1)}
      >
        <Text style={styles.glyph}>−</Text>
      </TouchableOpacity>
    </View>
  );
};

export default ZoomControls;

const styles = StyleSheet.create({
  wrap: {
    position: "absolute",
    right: 12,
    backgroundColor: tokens.surface,
    borderRadius: tokens.radius.md,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: tokens.borderLight,
    overflow: "hidden",
    ...cardElevation,
  },
  btn: {
    width: 40,
    height: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  divider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: tokens.borderLight,
  },
  glyph: {
    color: tokens.textPrimary,
    fontSize: 22,
    fontWeight: "600",
    lineHeight: 26,
  },
});
